module.exports = BVLazyLoad;